const staffOrderReward = () => import('@/views/main/staff/reward/reward.vue')
export default {
  path: '/main/staff/staffOrderReward',
  name: 'staffOrderReward',
  component: staffOrderReward,
  children: []
}
